import { render, staticRenderFns } from "./AuthorityGroupPrev.vue?vue&type=template&id=4a5d227e&"
import script from "./AuthorityGroupPrev.vue?vue&type=script&lang=ts&"
export * from "./AuthorityGroupPrev.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports